import {useEffect} from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {useNavigate, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

import yup from "../../utils/yup";
import Form from "../../components/form/Form";
import {resetPasswordConfirm} from "../../services/AuthService";
import NavLink from "../../components/NavLink";
import HelperFormButtons from "../../components/HelperFormButtons";


const ResetPasswordConfirm = () => {
  const [searchParams,] = useSearchParams();
  const navigate = useNavigate();

  const resetPasswordConfirmSchema = yup
    .object()
    .shape({
      code: yup
        .string("The code is not valid.")
        .required("The code is required."),
      password1: yup
        .string("The password is not valid.")
        .required("Please enter your password.")
        .min(10, "The password must be at least 10 characters long."),
      password2: yup
        .string("The repeat password is not valid.")
        .required("Please enter your password again.")
        .oneOf([yup.ref("password1")], "Your passwords do not match."),
    })
    .required();

  const formDetails = {
    label: "Confirm your password reset",
    submitButtonLabel: "Submit",
    steps: [
      {
        name: "code",
        label: "Reset password code",
        type: "text",
      },
      {
        name: "password1",
        label: "Password",
        type: "text",
                tooltip: <Tooltip title="The password only needs to be greater than 10 characters."><InfoIcon /></Tooltip>,
        htmlType: "password",
      },
      {
        name: "password2",
        label: "Repeat password",
        type: "text",
        htmlType: "password",
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(resetPasswordConfirmSchema),
    mode: "onChange",
  });

  const additionalFormButtons = [
    {
      label: "Log In",
      route: "/login",
    },
    {
      label: "Register",
      route: "/register",
    },
  ];

  useEffect(() => {
    if (searchParams.has('code')) {
      form.setValue('code', searchParams.get('code'));
    }
  }, [searchParams]);

  const handleSubmit = (values) => {
    resetPasswordConfirm(form.setError)(values).then(async (data) => {
      toast.success('You have successfully reset your password.');
      await window.localStorage.setItem(
        "availabilityTracker",
        JSON.stringify({
          user: data,
          accessTokenExpire: data.access_token_expire,
          refreshTokenExpire: data.refresh_token_expire,
        })
      );

      navigate("/employments");
    })
  }

  return (
    <Container>
      <Container>
        If you did not receive the code, you can request a new one{" "}
        <NavLink styles={{ textDecoration: 'underline' }} onClick="/reset-password" label="here." />
      </Container>
      <Form
        formDetails={formDetails}
        form={form}
        onSubmit={handleSubmit}
      />
      <Container className="mt-2">
        <Row>
          <HelperFormButtons formButtons={additionalFormButtons} />
        </Row>
      </Container>
    </Container>
  );
};

export default ResetPasswordConfirm;
